import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MessageMarkdownProps {
    children: string;
}

export function MessageMarkdown({children}: MessageMarkdownProps) {
    return (
        <div className="text-[#2c3e50] text-[0.9375rem] leading-relaxed space-y-2 break-words">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    p: ({children}) => <p>{children}</p>,
                    ul: ({children}) => <ul className="list-disc pl-5 space-y-1">{children}</ul>,
                    ol: ({children}) => <ol className="list-decimal pl-5 space-y-1">{children}</ol>,
                    strong: ({children}) => <strong className="font-semibold">{children}</strong>,
                    em: ({children}) => <em className="italic">{children}</em>,
                    h1: ({children}) => <h1 className="font-semibold text-base">{children}</h1>,
                    h2: ({children}) => <h2 className="font-semibold text-base">{children}</h2>,
                    h3: ({children}) => <h3 className="font-semibold">{children}</h3>,
                    blockquote: ({children}) => (
                        <blockquote className="border-l-2 border-[#e2e8f0] pl-3 text-[#6c757d]">{children}</blockquote>
                    ),
                    code: ({children}) => (
                        <code className="font-mono text-sm bg-[rgba(0,0,0,0.04)] px-1 py-0.5 rounded">{children}</code>
                    ),
                    a: ({children, href}) => (
                        <a href={href} target="_blank" rel="noopener noreferrer" className="text-[#356BAD] underline">
                            {children}
                        </a>
                    ),
                    table: ({children}) => (
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm border-collapse">{children}</table>
                        </div>
                    ),
                    th: ({children}) => (
                        <th className="border border-[#e2e8f0] px-2 py-1 text-left font-semibold">{children}</th>
                    ),
                    td: ({children}) => <td className="border border-[#e2e8f0] px-2 py-1">{children}</td>,
                }}
            >
                {children}
            </ReactMarkdown>
        </div>
    );
}
